import { Route, Switch } from 'react-router-dom';
import { Table } from 'src/view/components/Table/Table';
import { SCREENS } from 'src/constants/screens';
import BranchesScreen from 'src/view/screens/BranchesManagementScreen/screens/BranchesScreen/BranchesScreen';
import BranchEditScreen from 'src/view/screens/BranchesManagementScreen/screens/BranchEditScreen/BranchEditScreen';
import BranchesWorkingHours from '~/view/screens/BranchesManagementScreen/screens/BranchesWorkingHours/BranchesWorkingHours';
import CustomRoute from '~/view/components/CustomRoute/CustomRoute';
import { USER_ROLES } from '~/constants/user';

const BranchesManagementScreen = () => {
  return (
    <Table>
      <Switch>
        {/* Branches list */}
        <CustomRoute
          exact
          path={SCREENS.BRANCHES()}
          component={BranchesScreen}
          roles={[USER_ROLES.RESTAURANT_MANAGER]}
          redirectPath={SCREENS.BRANCHES_WORKING_HOURS()}
        />
        {/* Branch creation and edit */}
        <CustomRoute
          exact
          path={[SCREENS.BRANCHES_CREATE(), SCREENS.BRANCHES_EDIT(':id')]}
          component={BranchEditScreen}
          roles={[USER_ROLES.RESTAURANT_MANAGER]}
        />
        {/* Branches working hours */}
        <Route exact path={SCREENS.BRANCHES_WORKING_HOURS()} component={BranchesWorkingHours} />
      </Switch>
    </Table>
  );
};

export default BranchesManagementScreen;
